import { render, staticRenderFns } from "./PaymentsCarousel.vue?vue&type=template&id=4918f090&scoped=true"
import script from "./PaymentsCarousel.js?vue&type=script&lang=js&external"
export * from "./PaymentsCarousel.js?vue&type=script&lang=js&external"
import style0 from "./PaymentsCarousel.scss?vue&type=style&index=0&id=4918f090&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4918f090",
  null
  
)

export default component.exports